import styled from "styled-components"

export const ConfigureTtlLinkWrapper = styled.div`
    background-color: white;
  width: 100%;
  display: flex;
  margin-top: 2rem;
  justify-content: space-between;
  justify-content: space-between;
  padding: 1rem 8rem;
  align-items: center;
    `;

export const TtlLinkText = styled.p`
  font-size: 1.2rem;
`;

export const ButtonWrapper = styled.div`
    height: 4rem;
      `;